import c from "./ghl-ui.es1470.js";
function o(t, i, e) {
  var l = t.length;
  return e = e === void 0 ? l : e, !i && e >= l ? t : c(t, i, e);
}
export {
  o as default
};
